import { render, staticRenderFns } from "./sharedClient.vue?vue&type=template&id=72601429&scoped=true&"
import script from "./sharedClient.vue?vue&type=script&lang=js&"
export * from "./sharedClient.vue?vue&type=script&lang=js&"
import style0 from "./sharedClient.vue?vue&type=style&index=0&id=72601429&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72601429",
  null
  
)

export default component.exports